export type Phase = 'idle' | 'analysing' | 'offer' | 'feedback' | 'done';

/** Which optional steps this learner gets after a test. */
export interface Steps {
  offer: boolean;
  feedback: boolean;
}

/**
 * The step after `phase`: analysing, the plan offer, the feedback prompt, then the result itself.
 * Steps that do not apply are skipped, and the analysing screen only exists to lead into the offer.
 */
export function advance(phase: Phase, steps: Steps): Phase {
  switch (phase) {
    case 'idle':
      if (steps.offer) return 'analysing';
      return steps.feedback ? 'feedback' : 'done';
    case 'analysing':
      return 'offer';
    case 'offer':
      return steps.feedback ? 'feedback' : 'done';
    default:
      return 'done';
  }
}

/** The result dialog waits while one of the sequence's own steps is on screen. */
export const isBlocking = (phase: Phase): boolean =>
  phase === 'analysing' || phase === 'offer' || phase === 'feedback';
